// This file is part of Indico.
// Copyright (C) 2002 - 2020 CERN
//
// Indico is free software; you can redistribute it and/or
// modify it under the terms of the MIT License; see the
// LICENSE file for more details.

import './tpls/currency.tpl.html';
import './tpls/field.tpl.html';
import './tpls/fieldpicker.tpl.html';
import './tpls/registrationform.tpl.html';
import './tpls/section.tpl.html';
import './tpls/sectiontoolbar.tpl.html';
import './tpls/table.tpl.html';
import './tpls/toolbar.tpl.html';

import './tpls/dialogs/errors.tpl.html';
import './tpls/dialogs/sectioncreation.tpl.html';
import './tpls/dialogs/sectionmanagement.tpl.html';

import './tpls/fields/accommodation-config.tpl.html';
import './tpls/fields/accommodation-editionTable.tpl.html';
import './tpls/fields/accommodation.tpl.html';
import './tpls/fields/checkbox.tpl.html';
import './tpls/fields/country.tpl.html';
import './tpls/fields/date.tpl.html';
import './tpls/fields/dropdown.tpl.html';
import './tpls/fields/email.tpl.html';
import './tpls/fields/bool.tpl.html';
import './tpls/fields/file.tpl.html';
import './tpls/fields/label.tpl.html';
import './tpls/fields/multi_choice.tpl.html';
import './tpls/fields/number.tpl.html';
import './tpls/fields/phone.tpl.html';
import './tpls/fields/radio.tpl.html';
import './tpls/fields/radiogroup.tpl.html';
import './tpls/fields/text.tpl.html';
import './tpls/fields/textarea.tpl.html';

import './tpls/fields/dialogs/accomodationoptions.tpl.html';
import './tpls/fields/dialogs/base.tpl.html';
import './tpls/fields/dialogs/billable.tpl.html';
import './tpls/fields/dialogs/date.tpl.html';
import './tpls/fields/dialogs/defaultvalues.tpl.html';
import './tpls/fields/dialogs/inputtype.tpl.html';
import './tpls/fields/dialogs/itemtable.tpl.html';
import './tpls/fields/dialogs/number.tpl.html';
import './tpls/fields/dialogs/placeslimit.tpl.html';
import './tpls/fields/dialogs/rowsandcolumns.tpl.html';
import './tpls/fields/dialogs/size.tpl.html';

import './tpls/sections/dialogs/base.tpl.html';
import './tpls/sections/general.tpl.html';
import './tpls/sections/generalfield.tpl.html';
